import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { IntegrationHealthStatus } from "@/types/communication-integration";

interface HealthBadgeProps {
  status: IntegrationHealthStatus;
}

export const HealthBadge: React.FC<HealthBadgeProps> = ({ status }) => {
  const { t } = useTranslation();

  if (status === "HEALTHY") {
    return (
      <Badge variant="success">
        {t("communicationChannels.health.healthy")}
      </Badge>
    );
  }
  if (status === "UNHEALTHY_AUTH") {
    return (
      <Badge variant="new_destructive">
        {t("communicationChannels.health.unhealthyAuth")}
      </Badge>
    );
  }
  if (status === "UNHEALTHY_CONNECTION") {
    return (
      <Badge variant="new_destructive">
        {t("communicationChannels.health.unhealthyConnection")}
      </Badge>
    );
  }
  return (
    <Badge variant="new_secondary">
      {t("communicationChannels.health.unknown")}
    </Badge>
  );
};
